/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentColor = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        department: {
    type: 'string',
    isRequired: true,
},
        color: {
    properties: {
        id: {
    type: 'number',
},
        color: {
    type: 'string',
    isRequired: true,
},
    },
    isRequired: true,
},
    },
};